import { useSelector } from 'react-redux';
import adminLogo from '../../Images/admin_img.jpg';
import ReportingDashboard from '../../components/reportingDashbaord/ReportingDashbaord';

const DashboardPage = () => {
  const isSuperuser = useSelector((state) => state.user.isSuperuser);
  const image = useSelector((state) => state.user.image);


  return (
    <>
      <div
        className='table-container'
        style={{
          paddingBottom: '2rem',
          backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative'
        }}
      >
        <div
          className='table-inner-div'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 0
          }}
        />
        <ReportingDashboard />
      </div>
    </>
  );
};

export default DashboardPage;